import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-edtell-front-facing-card",
  templateUrl: "./edtell-front-facing-card.component.html",
  styleUrls: ["./edtell-front-facing-card.component.scss"],
})
export class EdtellFrontFacingCardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
